import { render, staticRenderFns } from "./StandardJob.vue?vue&type=template&id=19cf9b27&scoped=true"
import script from "./StandardJob.vue?vue&type=script&lang=js"
export * from "./StandardJob.vue?vue&type=script&lang=js"
import style0 from "./StandardJob.vue?vue&type=style&index=0&id=19cf9b27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cf9b27",
  null
  
)

export default component.exports